<template>
    <div class="context common_table_view" ref="common_table_view">
        <div class="header" ref="header">
            <div class="search search_box">
                <el-form :model="searchForm"
                         class="search_form"
                         inline
                         size="small">
                    <el-form-item label="药师名称:">
                        <el-input class="width_220"
                                  @change="getTableData()"
                                  clearable
                                  v-model="searchForm.input">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input class="width_220"
                                  @change="getTableData()"
                                  clearable
                                  v-model="searchForm.phone">
                        </el-input>
                    </el-form-item>

                    <el-form-item>
                        <div class="search_btn">
                            <el-button type="primary"
                                       @click="getTableData()">
                                搜索
                            </el-button>
                        </div>
                    </el-form-item>

                </el-form>
            </div>
            <div class="btn_box">
                <el-button type="primary"
                           @click="addHos"
                           size="small">
                    添加药师
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      :height="tableHeight">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page" ref="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        data() {
            return {
                tableHeight: 0,
                searchForm: {
                    input: '',
                    phone: '',
                },
                cityList: [],
                cascader_props: {
                    expandTrigger: 'hover',
                    value: 'name',
                    label: 'name',
                    children: 'city_list',
                },

                tableData: [],
                columnData: [
                    {label: '药师名字', prop: 'name'},
                    {label: '手机号', prop: 'phone'},
                    {label: '职称', prop: 'title'},
                    {label: '药店名称', prop: 'pharmacy_name'},
                    {label: '地址', prop: 'address'},
                ],
                total: 0,
                currentPage: 1,
                pageSize: 50,
            }
        },
        computed: {},
        mounted() {
            this.getTableData();
            this.$eventBus.$on("pollPort",() =>{
                this.getTableData()
            })
            this.$nextTick(() =>{
                this.tableHeight = this.$refs.common_table_view.clientHeight - this.$refs.header.clientHeight - this.$refs.bottom_page.clientHeight
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations('manageData', {
                setPharmacistData: 'setPharmacistData'
            }),
            addHos() {
                this.setPharmacistData(null);
                this.$emit('changeTopTab', 'addView')
            },
            editRow(row) {
                this.setPharmacistData(row);
                this.$emit('changeTopTab', 'addView')
            },

            delRow(row) {
                this.$confirm('确定删除该药师么？').then(() => {
                    this.httpDel(`/pharmacist/${row.user_id}`).then(res => {
                        this.$message.success('删除成功！');
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    })
                }).catch(() => {
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                console.log('get_data');
                let params = {
                    name: this.searchForm.input,
                    phone: this.searchForm.phone,
                    page: v,
                    page_size: this.pageSize
                };
                this.httpGet('/pharmacist/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>